import axios from "axios";
import { getCookies, setCookies, rmCookie } from "./Util";
import { API_SERVER_URL } from "./config";

const path = API_SERVER_URL;
const EXPIRRY_TIME = 60 * 1000 * 60;

export const requestLoginPost = async (url: string, param: any) => {
  setCookies("menu", {});
  var data: any = "";

  await axios
    .post(path + url, param, {
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
    })
    .then((response) => {
      let responseData = response.data;
      data = responseData;
      
      let refreshToken = response.headers["at-jwt-reflesh-token"];
      setCookies("IDT", refreshToken, {
        path: "/",
        sameSite: "strict",
      });
      onLoginSuccess(response);
    })
    .catch((response) => {});
  return data;
};

export const requestGet = async (url: string, param: any, reload = 0) => {
  var data: any = "";

  await axios
    .get(path + url, {
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
      params: param,
    })
    .then((response) => {
      data = response.data;
      let accessToken = response.headers["at-jwt-access-token"];
      if (accessToken !== undefined) {
        axios.defaults.headers.common["accessToken"] = accessToken;
      }
    })
    .catch(async (error) => {
      var refresh = false;
      if (reload === 0) {
        refresh = await onSlientRefresh();
      }

      if (refresh === true) {
        data = await requestGet(url, param, 1);
      } else {
        data = false;
        tokenExpiration();
      }
    });

  return data;
};
//post
export const requestPost = async (url: string, param: any, reload = 0) => {
  var data: any = "";

  await axios
    .post(path + url, param, {
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
    })
    .then((response) => {
      data = response.data;
      let accessToken = response.headers["at-jwt-access-token"];
      if (accessToken !== undefined) {
        axios.defaults.headers.common["accessToken"] = accessToken;
      }
    })
    .catch(async (error) => {
      var refresh = false;
      if (reload === 0) {
        refresh = await onSlientRefresh();
      }

      if (refresh === true) {
        data = await requestPost(url, param, 1);
      } else {
        data = false;
        tokenExpiration();
      }
    });

  return data;
};

//파일 list업로드
export const requestFormData = async (
  url: string,
  formData: any,
  reload = 0
) => {
  var data: any = "";

  await axios
    .post(path + url, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then((response) => {
      data = response.data;
      let accessToken = response.headers["at-jwt-access-token"];
      if (accessToken !== undefined) {
        axios.defaults.headers.common["accessToken"] = accessToken;
      }
    })
    .catch(async (error) => {
      var refresh = false;
      if (reload === 0) {
        refresh = await onSlientRefresh();
      }

      if (refresh === true) {
        data = await requestFormData(url, formData, 1);
      } else {
        data = false;
      }
    });

  return data;
};

//파일업로드
export const requestFileUpload = async (url: string, file: any, reload = 0) => {
  var data: any = "";
  const formData = new FormData();
  formData.append("file", file);
  await axios
    .post(path + url, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then((response) => {
      data = response.data;
      let accessToken = response.headers["at-jwt-access-token"];
      if (accessToken !== undefined) {
        axios.defaults.headers.common["accessToken"] = accessToken;
      }
    })
    .catch(async (error) => {
      var refresh = false;
      if (reload === 0) {
        refresh = await onSlientRefresh();
      }

      if (refresh === true) {
        data = await requestFileUpload(url, file, 1);
      } else {
        data = false;
      }
    });

  return data;
};

export const onSlientRefresh = async () => {
  var data: boolean = false;
  let IDL = getCookies("IDL");
  if (IDL === undefined) {
    return data;
  }
  var refleshToken = getCookies("IDT");
  if (refleshToken === undefined) {
    return data;
  }
  await axios
    .post(
      path + "/api/silent-refresh",
      { refleshToken: refleshToken },
      {
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
        },
      }
    )
    .then((response) => {
      data = response.data;

      if (data === true) {
        onLoginSuccess(response);
      }
    })
    .catch((response) => {
      tokenExpiration();
    });

  return data;
};

const onLoginSuccess = (response: any) => {
  let accessToken = response.headers["at-jwt-access-token"];
  axios.defaults.headers.common["accessToken"] = `${accessToken}`;

  setCookies("IDL", Date.now(), {
    path: "/",
    sameSite: "strict",
    expires: new Date(Date.now() + EXPIRRY_TIME),
  });

  setCookies("IDSTS", true, {
    path: "/",
    sameSite: "strict",
    expires: new Date(Date.now() + EXPIRRY_TIME),
  });
  setTimeout(onSlientRefresh, EXPIRRY_TIME - 60000);
};

//파일 수정
export const requestEditFormData = async (
  url: string,
  formData: any,
  reload = 0
) => {
  var data: any = "";

  await axios
    .put(path + url, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then((response) => {
      data = response.data;
      let accessToken = response.headers["at-jwt-access-token"];
      if (accessToken !== undefined) {
        axios.defaults.headers.common["accessToken"] = accessToken;
      }
    })
    .catch(async (error) => {
      var refresh = false;
      if (reload === 0) {
        refresh = await onSlientRefresh();
      }

      if (refresh === true) {
        data = await requestEditFormData(url, formData, 1);
      } else {
        data = false;
      }
    });

  return data;
};

export const requestFormDataPost = async (
  url: string,
  formData: any,
  reload = 0
) => {
  var data: any = "";

  await axios
    .post(path + url, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then((response) => {
      data = response.data;
      let accessToken = response.headers["at-jwt-access-token"];
      if (accessToken !== undefined) {
        axios.defaults.headers.common["accessToken"] = accessToken;
      }
    })
    .catch(async (error) => {
      var refresh = false;
      if (reload === 0) {
        refresh = await onSlientRefresh();
      }

      if (refresh === true) {
        data = await requestFormData(url, formData, 1);
      } else {
        data = false;
      }
    });

  return data;
};

const tokenExpiration = () => {
  rmCookie();
  window.location.replace("/login");
};

